import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../../components/ui/card';
import Logo from '../../assets/images/stratagenIcon.png';
import { useEffect, useRef, useCallback } from 'react';
import Auth0Lock from 'auth0-lock';
import { applyTheme } from '../../utils/theme';
import { setStoredAccessToken } from '../../utils/authToken';

const Login = () => {
  const navigate = useNavigate();
  const lockRef = useRef<any>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const { AUTH0_DOMAIN, AUTH0_CLIENT_ID } = (window as any).data.auth;

  const initializeLock = useCallback(() => {
    if (!containerRef.current || lockRef.current) return;

    lockRef.current = new Auth0Lock(AUTH0_CLIENT_ID, AUTH0_DOMAIN, {
      container: containerRef.current.id,
      closable: false,
      theme: {
        primaryColor: '#ea580c',
        labeledSubmitButton: true,
      },
      auth: {
        redirectUrl: window.location.href,
        responseType: 'token id_token',
        params: {
          scope: 'openid profile email',
        },
      },
      languageDictionary: {
        title: 'welcome',
      },
      allowSignUp: true,
      initialScreen: 'signUp',
      rememberLastLogin: false,
    });

    const handleAuthentication = async (authResult: any) => {
      try {
        const getUserInfo = () => {
          return new Promise((resolve, reject) => {
            lockRef.current?.getUserInfo(
              authResult.accessToken,
              (error: any, profile: any) => {
                if (error) reject(error);
                else resolve(profile);
              }
            );
          });
        };
        await getUserInfo();
        setStoredAccessToken(authResult.accessToken);
        navigate('/home');
      } catch (error) {
        console.error('Authentication error:', error);
      }
    };

    lockRef.current.on('authenticated', handleAuthentication);
    lockRef.current.show();
  }, [navigate]);

  useEffect(() => {
    initializeLock();
  }, [initializeLock]);

  useEffect(() => {
    const hadDark = document.documentElement.classList.contains('dark');
    applyTheme('light');
    return () => {
      if (hadDark) applyTheme('dark');
      else applyTheme('light');
    };
  }, []);

  return (
    <div className="w-full flex justify-center items-center min-h-screen bg-neutral-50 text-slate-900">
      <div className="text-4xl flex flex-col gap-2 h-full justify-center items-center">
        <div className="flex gap-2">
          <img src={Logo} alt="Logo" className="w-16 h-16 mt-2" />
          <div className="flex flex-col">
            <span className="text-[#201D46]">Stratagen</span>
            <span className="text-[#201D46]">bio</span>
          </div>
        </div>
        <div className="text-3xl font-medium text-slate-900">Dashboard</div>
      </div>
      <div className="w-[350px] h-[500px]">
        <Card className="w-[350px] border border-slate-200 bg-white shadow-lg ml-10">
          <CardContent className="p-0 items-center">
            <div
              ref={containerRef}
              id="auth0-login-container"
              className="min-h-[500px]"
            />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Login;
